import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
export const ActionCardSkeleton: FC<{
  className?: string;
}> = t0 => {
  const $ = _c(8);
  const {
    className
  } = t0;
  const t1 = `relative flex h-[506px] flex-col items-center justify-between overflow-hidden rounded-[20px] md:h-[575px] animate-pulse ${className}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute inset-0 z-0 bg-white/10" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center gap-2.5"><div className="h-[18px] w-24 rounded bg-white/20" /><div className="h-5 w-5 rounded-full bg-white/20" /></div>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col gap-2">{t3}<div className="flex min-h-[50px] flex-col gap-1.5"><div className="h-6 w-full rounded bg-white/20" /><div className="h-6 w-2/3 rounded bg-white/20" /></div></div>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="h-4 w-14 rounded bg-white/20" />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex flex-col gap-2">{t5}<div className="flex gap-2"><div className="h-[34px] w-[72px] rounded-[100px] bg-white/20" /><div className="h-[34px] w-[72px] rounded-[100px] bg-white/20" /></div></div>;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="relative z-10 mt-auto w-full rounded-[14px] bg-[rgba(23,23,35,0.8)] p-4"><div className="flex min-h-[180px] flex-col gap-4">{t4}<div className="mt-auto flex min-h-[70px] items-end justify-between">{t6}<div className="flex flex-col items-end gap-2"><div className="h-4 w-10 rounded bg-white/20" /><div className="h-[34px] w-[70px] rounded-[100px] bg-white/20" /></div></div></div></div>;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t1) {
    t8 = <div className={t1}>{t2}{t7}</div>;
    $[6] = t1;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  return t8;
};